import { OPERATION_IDS } from '../routes/ids.js';
import { BRANCH_CREATE_FORM as BASE_BRANCH_CREATE_FORM, BRANCH_EDIT_FORM as BASE_BRANCH_EDIT_FORM, } from './form-registry.js';
import { ORGANIZATION_BRANCHES_TABLE as BASE_BRANCH_TABLE } from './table-registry.js';
const lifecycleReasonField = {
    id: 'field.branch.lifecycleReason',
    name: 'reason',
    labelKey: 'field.branch.disableReason',
    fieldType: 'textarea',
    layout: { md: 12 },
    value: { hiddenValuePolicy: 'clear', clearWhenHidden: true, submitBehavior: 'include' },
    state: {
        visibilityCondition: {
            operator: 'in',
            field: 'field.branch.status',
            values: ['SUSPENDED', 'INACTIVE'],
        },
        requiredCondition: {
            operator: 'in',
            field: 'field.branch.status',
            values: ['SUSPENDED', 'INACTIVE'],
        },
    },
    validation: {
        rules: [{ ruleId: 'required', messageKey: 'validation.required' }],
        validateWhen: 'submit',
    },
};
export const BRANCH_CREATE_FORM = BASE_BRANCH_CREATE_FORM;
export const BRANCH_EDIT_FORM = {
    ...BASE_BRANCH_EDIT_FORM,
    fields: [...BASE_BRANCH_EDIT_FORM.fields, lifecycleReasonField],
    submission: {
        ...BASE_BRANCH_EDIT_FORM.submission,
        includeFields: [
            ...(BASE_BRANCH_EDIT_FORM.submission.includeFields ?? BASE_BRANCH_EDIT_FORM.fields.map((field) => field.id)),
            lifecycleReasonField.id,
        ],
    },
};
const makeDefaultAction = {
    id: 'action.organizationBranch.makeDefault',
    schemaVersion: BASE_BRANCH_TABLE.schemaVersion,
    module: BASE_BRANCH_TABLE.module,
    feature: BASE_BRANCH_TABLE.feature,
    privacyClassification: BASE_BRANCH_TABLE.privacyClassification,
    telemetryId: `${String(BASE_BRANCH_TABLE.telemetryId)}.make-default`,
    accessibilityLabelKey: 'field.branch.isDefault',
    availability: 'AVAILABLE',
    owner: 'experience-registry',
    operationId: OPERATION_IDS.ORGANIZATION_BRANCHES_MAKE_DEFAULT,
    labelKey: 'field.branch.isDefault',
    iconKey: 'approve',
    kind: 'command',
    method: 'PATCH',
    commandId: 'cmd.admin.organization-branches.make-default',
    intent: 'primary',
    idempotencyRequired: true,
    confirmation: {
        titleKey: 'common:confirmAction',
        messageKey: 'common:confirmAction',
        confirmLabelKey: 'field.branch.isDefault',
        cancelLabelKey: 'action.cancel',
    },
    successBehavior: 'REFRESH_TABLE',
    successMessageKey: 'common:success',
    errorBehavior: 'SHOW_INLINE_ERROR',
    errorMessageKey: 'common:error.unexpected',
    visibilityCondition: {
        operator: 'and',
        conditions: [
            { operator: 'equals', field: 'status', value: 'ACTIVE' },
            { operator: 'equals', field: 'isDefault', value: false },
        ],
    },
    order: 15,
    group: 'primary',
};
export const ORGANIZATION_BRANCHES_TABLE = {
    ...BASE_BRANCH_TABLE,
    rowActions: [
        ...(BASE_BRANCH_TABLE.rowActions ?? []),
        makeDefaultAction,
    ].sort((left, right) => (left.order ?? 0) - (right.order ?? 0)),
};
